import type { SelectOption } from '@camelot/components'
import type { AirportZoneRto } from '~/api/location'
import type { Address } from '~/types/location'

const DEFAULT_NAME = 'Airport'

export function mapAirportZoneToSelectOption(airportZone: AirportZoneRto): SelectOption {
  const location = airportZone.centerPosition
    ? { latitude: airportZone.centerPosition?.latitude, longitude: airportZone.centerPosition?.longitude }
    : undefined

  const value: Address = {
    info: airportZone.zoneName ?? DEFAULT_NAME,
    location,
  }

  return {
    prefixIcon: 'airport',
    label: airportZone.zoneName ?? DEFAULT_NAME,
    value,
  }
}
